/* File: src/components/common/Input.js */
import React from 'react';
import './Input.css';

/**
 * Composant Input réutilisable qui respecte la charte graphique de Guinness
 * 
 * @param {Object} props - Propriétés du composant
 * @param {string} props.type - Type de l'input (text, number, tel, etc.)
 * @param {string} props.id - Identifiant unique de l'input
 * @param {string} props.name - Nom du champ de formulaire
 * @param {string} props.label - Libellé du champ
 * @param {string} props.value - Valeur du champ
 * @param {string} props.placeholder - Texte d'aide
 * @param {boolean} props.required - Si le champ est requis
 * @param {boolean} props.disabled - Si le champ est désactivé
 * @param {string} props.error - Message d'erreur à afficher
 * @param {Function} props.onChange - Fonction appelée lors de la modification du champ
 * @param {Function} props.onBlur - Fonction appelée lors de la perte de focus
 * @param {string} props.className - Classes CSS supplémentaires
 * @param {Object} props.rest - Autres propriétés à passer à l'input
 */
const Input = ({
  type = 'text',
  id,
  name,
  label,
  value,
  placeholder = '',
  required = false,
  disabled = false,
  error = '',
  onChange,
  onBlur,
  className = '',
  ...rest
}) => {
  const inputId = id || name;
  const hasError = !!error;

  // Déterminer les classes CSS en fonction des props
  const inputClasses = [
    'guinness-input',
    hasError ? 'guinness-input-error' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="guinness-input-container">
      {label && (
        <label 
          htmlFor={inputId} 
          className="guinness-input-label"
        >
          {label}
          {required && <span className="guinness-input-required">*</span>}
        </label>
      )}
      
      <input
        type={type}
        id={inputId}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className={inputClasses}
        required={required}
        {...rest}
      />
      
      {hasError && (
        <div className="guinness-input-error-message">{error}</div>
      )}
    </div>
  );
};

export default Input;